import React from 'react'

const Footer = () => {
  return (
    <div className="Footer">
      <div className="container">
        <div className="line"></div>
        <p>جميع الحقوق علاء الدين حامد المحامي بالنقض © 2025 • HORIZONYA</p>
      </div>
    </div>
  );
}

export default Footer